import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { set } from 'lodash';

interface agreementCheckboxes {
    termsOfService: boolean,
    privacyPolicy: boolean,
    marketingEmails: boolean,
}

interface branchesData {
    project: string,
    branch: string,
    user: string,
}

interface productionState {
    agreementCheckboxesData: agreementCheckboxes;
    offerId: string | null;
    leadId: string | null;
    idForLeadPopup: string | null;
    leadStore: any;
    simulatorData: any;
    branchesData: branchesData;


}

const initialState: productionState = {
    agreementCheckboxesData: {
        termsOfService: false,
        privacyPolicy: false,
        marketingEmails: false,
    },
    offerId: '',
    leadId: '',
    idForLeadPopup: null,
    leadStore: null,
    simulatorData: null,
    branchesData: {
        project: '',
        branch: '',
        user: '',
    }
}

export const policyProductionSlice = createSlice({
    name: 'policyProduction',
    initialState,
    reducers: {

        setAgreementByNumber: (state, action: PayloadAction<agreementCheckboxes>) => {

            console.log('action.payload', action.payload)
            state.agreementCheckboxesData = { ...action.payload };
        },
        setOfferId: (state, action: PayloadAction<string | null>) => {
            state.offerId = action.payload || null;
        },
        setLeadId: (state, action: PayloadAction<string | null>) => {
            state.leadId = action.payload || null;
        },
        setIdForLeadPopup: (state, action: PayloadAction<string | null>) => {
            state.idForLeadPopup = action.payload || null;
        },
        setLeadStore: (state, action: PayloadAction<any | null>) => {
            state.leadStore = action.payload;
        },
        setSimulatorData: (state, action: PayloadAction<any | null>) => {
            state.simulatorData = action.payload;
        },
        setBranchesData: (state, action: PayloadAction<branchesData>) => {
            console.log('action.payload', action.payload)
            state.branchesData = { ...action.payload };
        },
        //   logIn: (state) => {
        //     state.value = true
        //   },
        //   logOut: (state) => {
        //     state.value = false
        //   }
    },
})
export const { setAgreementByNumber, setOfferId, setLeadId, setIdForLeadPopup, setLeadStore, setSimulatorData, setBranchesData } = policyProductionSlice.actions
export default policyProductionSlice.reducer